/* eslint-disable @typescript-eslint/no-explicit-any */
import { child, get, push, ref, set } from 'firebase/database';
import { db } from '../../../firebase';

const dbRef = ref(db);
const ORIGIN = 'firebase';

const debugAction = (...params: any[]) => console.info(...params);

const getAll = async (resource: string): Promise<any[]> => {
    debugAction(ORIGIN, 'getAll', resource);
    return await get(child(dbRef, resource))
        .then((snapshot) => {
            if (snapshot.exists()) {
                if (snapshot.val()) {
                    const items: any[] = [];
                    snapshot.forEach((child) => {
                        items.push({
                            ...child.val(),
                            id: child.key,
                        });
                    });
                    return items.filter((i) => !i.deleted);
                }
            }
            return [];
        })
        .catch((error) => {
            console.error(error);
            return [];
        });
};

const getOne = async (
    resource: string,
    id: string | undefined
): Promise<any> => {
    debugAction(ORIGIN, 'getOne', resource, id);
    if (id) {
        return await get(child(dbRef, resource + '/' + id))
            .then((snapshot) => {
                if (snapshot.exists()) {
                    if (snapshot.val()) {
                        return snapshot.val();
                    }
                }
                return undefined;
            })
            .catch((error) => {
                console.error(error);
                return undefined;
            });
    }
};

const getOneByHash = async (
    resource: string,
    hash: string | undefined
): Promise<any> => {
    debugAction(ORIGIN, 'getOneByHash', resource, hash);
    if (hash) {
        const elements = await getAll(resource);
        return elements.filter((element) => element.hash === hash)[0];
    }
};

const save = (resource: string, id: string | undefined, data: any) => {
    debugAction(ORIGIN, 'save', resource, id);
    if (id) {
        set(ref(db, `${resource}/${id}`), data);
    }
};

const append = (resource: string, data: any) => {
    debugAction(ORIGIN, 'append', resource);
    if (resource) {
        const newElement = push(ref(db, resource), data);
        return newElement.key;
    }
};

export { getAll, getOne, getOneByHash, save, append };
